import axios from '../../../helpers/custom-axios';
import {
  confirmation,
  notify,
  loadingBlock,
} from '../../../helpers/notifications';

export const handleCreateField = async (field) => {
  loadingBlock.add('.fields', 'Updating existing submissions...');
  return axios
    .post('manage/fields', field)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    })
    .finally(() => loadingBlock.remove('.fields'));
};

export const handleUpdateField = async (id, field) => {
  return axios
    .put(`/manage/fields/${id}`, field)
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleDestroyField = async (id, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/fields/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        let message =
          error?.errors?.base?.join('. ') || 'Something went wrong...';
        notify.alertFailure('Error', message);
        callback(error);
      });
  });
};

export const handleCopyField = async (id, callback) => {
  confirmation.copy(async () => {
    loadingBlock.add('.fields', 'Updating existing submissions...');
    return axios
      .get(`/manage/fields/${id}/copy`)
      .then((res) => {
        notify.success('Field copied');
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      })
      .finally(() => loadingBlock.remove('.fields'));
  });
};

export const checkFieldResponsesExist = async (fieldsetID) => {
  return axios
    .get(`/manage/fieldsets/${fieldsetID}/field_validity`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error.response);
      return error;
    });
};

export const hasValidResponses = (validityArray, fieldId) => {
  let valid;
  // fieldValidity passed in as [[field_id, boolean], ...]
  if (validityArray.length) {
    let field = validityArray.find((field) => field[0] == fieldId);
    valid = field ? field[1] : false;
  }
  return valid;
};

export const handleFetchFieldDetails = async (id) => {
  return axios
    .get(`/manage/fields/${id}/field_details`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error(error.response);
      return error;
    });
};
